import { Marketer } from '@/shared/model/marketer.model';
import { IMarketerStore } from './types';

export const state: IMarketerStore = {
  marketer: new Marketer(),
  tab: 'dashboard',
  drawer: false,
  businessCardSimulator: false,
};
